/**
* CUBE-FRONT - Entry Point
*/

/**
*  Load "Commons"
*/
require('./commons/commons');


/**
*  Load "CUBE"
*
*
* - For the moment :
*  All parts of the CUBE application are loaded here.
*  The result is a 'big' output JS file.
*
* - In the future :
*  When a good part of the existing CUBE will be migrated,
*  each scope will be separated within several (light) files.
*
*  Those scopes are :
*      - Homepage              > homepage.js
*      - Account               > account.js
*      - Checkout              > checkout.js
*      - Catalog               > catalog.js
*          + ProductList
*          + ProductDetails
*      - Other pages           > others.js
*          + Static pages
*          + CMS pages (...)
*/



// DOM READY
document.addEventListener('DOMContentLoaded', () => {

  // Account
  if ($('body.account').length)
  require('./account');

  // Authentication //
  require('./authentication');

  // Others pages
  require('./pages');

  /**
  * init lazyloading
  */
  cube.lazyload.init();

  // Store Entry Point ---

  // StoreLocator

  let urlScriptWoosmap = 'https://sdk.woosmap.com/locator/loader.js';

  if (window.tc_vars.env_country === 'CN') {
    urlScriptWoosmap = 'https://sdk.woosmap.cn/locator/loader.js';
  }

  if ($('.decathlon-woosmap-store-locator').length) {
    $.getScript( urlScriptWoosmap, require('./pages/store-locator/store-locator') );
  }

});





// WEBPACK FOOTER //
// ./src/modules-es5/index.js